/**
 * Below this pace a walker is seen sliding at its own speed rather than
 * easing in: the scene's easing crosses a tile in a quarter of a second,
 * so a creature that steps once a second would dart, then stand (the gold
 * cart, ADR 0050).
 */
export const STEADY_GLIDE_BELOW_TPS = 1.5;
/** A touch faster than its pace: a step that lands a tick early is not waited for. */
const PACE_MARGIN = 1.05;

/**
 * One frame of a steady slide from `current` toward `target`, in pixels: at
 * `tilesPerSecond`, faster in proportion when more than a tile behind, never
 * past the target.
 */
export function steadyGlide(
  current: { x: number; y: number },
  target: { x: number; y: number },
  deltaMs: number,
  tilesPerSecond: number,
  tileSize: number,
): { x: number; y: number } {
  const dx = target.x - current.x;
  const dy = target.y - current.y;
  const distance = Math.hypot(dx, dy);
  if (distance === 0) return { x: target.x, y: target.y };
  const behind = Math.max(1, distance / tileSize);
  const step = ((tilesPerSecond * PACE_MARGIN * tileSize) / 1000) * deltaMs * behind;
  if (step >= distance) return { x: target.x, y: target.y };
  return { x: current.x + (dx / distance) * step, y: current.y + (dy / distance) * step };
}
